<template>
  <div>
    <v-card>
      <v-card-title primary-title>
        <v-layout row wrap>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs6>
              <v-img src="img/Turtle.png" aspect-ratio="1.7"></v-img>
            </v-flex>
            <v-flex xs6 class="card-item">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    name="code"
                    label="Código"
                    id="code"
                    v-model="itemData.serial_number"
                    outline
                    @focus="$event.target.select()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    item-text="label"
                    item-value="value"
                    :items="turtleContentOptions"
                    v-model="itemData.turtle_content"
                    label="Contenido"
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="Price"
                    label="Precio"
                    id="price"
                    type="number"
                    v-model="itemData.turtle_price"
                    @focus="$event.target.select()"
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 text-xs-right>
              <v-btn color="success" @click="addItem">Agregar</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      turtleContentOptions: [
        {label: 'Llena', value: 'WHOLE'},
        {label: 'Tres cuartos', value: 'THREE_QUARTER'},
        {label: 'Media', value: 'HALF'},
        {label: 'Un cuarto', value: 'QUARTER'},
      ],
      defaultItemData: {
        serial_number: '',
        turtle_content: 'WHOLE',
        turtle_price: 0.00,
        type: 'TURTLE',
      },
      itemData: {
        serial_number: '',
        turtle_content: 'WHOLE',
        turtle_price: 0.00,
        type: 'TURTLE',
      },
    };
  },
  computed: {
  },
  methods: {
    addItem() {
      if (this.isLineValid()) {
        this.itemData.turtle_price = parseFloat(this.itemData.turtle_price, 10);
        this.$emit('add-item', this.itemData);
        this.itemData = Object.assign({}, this.defaultItemData);
      } else {
        this.$emit('warning', '');
      }
    },
    isLineValid() {
      return  true ;
    },
  },
};
</script>